<script setup lang="ts">

import { ref } from 'vue';
import { useAuthentication } from '../Types/Authentication';
import { usePresentation } from '../Types';

const auth = useAuthentication();
const password = ref<string>();
const showMessage = ref( false );
const presentation = usePresentation();

const onSubmit = function()
{
    if( ( password.value ?? '' ).length == 0 ) return;
    auth.authenticate( presentation, password.value );
    showMessage.value = auth.isAuthenticated == false;
}

</script>

<template>

    <div class="flex flex-col min-h-full grow items-center justify-center gap-8">
        
        <Image :src="presentation.theme.logo" class="w-4/5 md:w-3/5 lg:w-2/5" />

        <h2 class="text-2xl md:text-3xl lg:text-4xl text-cyan-500 font-semibold uppercase text-center">
            Enter your password to continue
        </h2>

        <v-form
            class="flex flex-col justify-center items-center w-64"
            @submit.prevent="onSubmit">

            <div class="w-full rounded-md">
                <TextField
                    v-model="password"
                    block 
                    color="rgb(0,0,0)"
                    :bg-color="presentation.theme.bgColorFrom == '#ffffff' ? '#aaaaaa' : undefined"
                    :variant="presentation.theme.bgColorFrom == '#ffffff' ? 'filled' : undefined"
                    class="w-full"
                    hide-details
                    type="password"
                    :rules="[ (v: string) => v?.length > 0 ]"
                />
            </div>

            <div v-if="showMessage" 
                class="text-rose-400 mt-1">
                Password is incorrect
            </div>
            <v-btn 
                :disabled="( password ?? '' ).length < 1"
                variant="flat"
                color="secondary"
                class="mt-4"
                size="large"
                block
                :class="{ '!opacity-20': ( password ?? '' ).length < 1 }"
                @click="onSubmit">
                Submit
            </v-btn>
        </v-form> 

    </div>

</template>